<template>
  <span class="pl-1">
    <span v-if="!newIcon">
      <v-icon
        small
        color="blue"
        v-on:click.stop.prevent="showPopup = !showPopup"
        :title="title"
        >fas fa-info-circle</v-icon
      >
    </span>
    <span
      class="newButton"
      v-if="newIcon"
      v-on:click.stop.prevent="showPopup = !showPopup"
    >
      NEW
    </span>
    <v-dialog v-model="showPopup" color="white" width="1260">
      <v-card>
        <v-tabs fixed-tabs v-model="selectedTab">
          <v-tab key="RR"> What are Risk Ratings? </v-tab>
          <v-tab key="Stability" v-if="hasPulseAccess">
            What is {{ labels.pulse }}?
          </v-tab>
          <v-tab key="both" v-if="hasPulseAccess">
            How do I use them Together?
          </v-tab>
          <v-tab key="EVACUATION_LEVELS">
            Evacuation Methodology Levels
          </v-tab>
          <v-tab key="VERIFIED_EVENTS">
            Verified Events Methodology
          </v-tab>
          <v-tab key="CALENDAR_EVENTS" v-if="calendarMethodology">
            {{ labels.calendarEvents }} Methodology
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item key="RR">
            <RiskRatingDefinitions
              :rating-id="ratingId"
              :params="params"
            ></RiskRatingDefinitions>
          </v-tab-item>
          <v-tab-item key="Stability" v-if="hasPulseAccess">
            <StabilityDescriptionV2
              v-if="featureUnlocked(`pulse-api-v2`)"
            ></StabilityDescriptionV2>
            <StabilityDescription v-else></StabilityDescription>
          </v-tab-item>
          <v-tab-item key="both" v-if="hasPulseAccess">
            <v-card>
              <v-card-text>
                <p>
                  PulseAI and Risk Ratings provide complementary indicators of a
                  country’s threat, risk and operating environment:
                </p>

                <p>
                  Risk ratings: give an at-a-glance, qualitative assessment of
                  current levels of risk to operations in a country. They are
                  business focused, and cover various categories including
                  political stability and attitude to investment; condition of
                  infrastructure; and security issues such as unrest and
                  terrorism.
                </p>

                <p>
                  PulseAI: gives a more immediate indication of changing levels
                  of stability based on how various indicators deviate from
                  baseline levels. Indicators can be longer term (various
                  economic measures) or short term (number of events). PulseAI
                  reacts more quickly than risk ratings, and captures more
                  subtle changes – a sudden upsurge in civil unrest or the start
                  of a new military campaign.
                </p>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="EVACUATION_LEVELS">
            <EvacuationDefinitions></EvacuationDefinitions>
          </v-tab-item>
          <v-tab-item key="VERIFIED_EVENTS">
            <VerifiedEventDefinitions></VerifiedEventDefinitions>
          </v-tab-item>
          <v-tab-item key="CALENDAR_EVENTS" v-if="calendarMethodology">
            <v-card>
              <v-card-text class="pb-0">
                <v-card-text>
                  <div v-html="calendarMethodology.body"></div>
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            style="margin: auto;"
            text
            @click="showPopup = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { LABELS } from "@/common/constants/labels";
import { RISK_RATING_PRIMARIES } from "@/common/constants/controlRisks/risks";
import { hasPulseAccess } from "@/services/user/user.service";
import { getCalendarMethodology } from "@/services/common/methodology.service";

const TABS = {
  RR: 0,
  STABILITY: 1,
  BOTH: 2,
  EVACUATION_LEVELS: 3,
  VERIFIED_EVENTS: 4,
};

export default {
  name: "PulseAndRiskDescription",
  components: {
    StabilityDescription: () =>
      import("@/components/grids/stability/StabilityDescription"),
    StabilityDescriptionV2: () =>
      import("@/components/grids/stability/StabilityDescriptionV2"),
    RiskRatingDefinitions: () =>
      import("@/components/controlRisks/risks/RiskRatingDefinitions"),
    EvacuationDefinitions: () =>
      import("@/components/controlRisks/evacuation/EvacuationDefinitions"),
    VerifiedEventDefinitions: () =>
      import("@/components/events/VerifiedEventDefinitions"),
  },
  props: {
    initial: {
      type: String,
      default: TABS.STABILITY,
    },
    ratingId: {
      type: String,
      default: null,
    },
    newIcon: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    title: {
      type: String,
      default: "View Pulse and Risk Rating descriptions",
    },
  },
  data() {
    return {
      labels: LABELS,
      showPopup: false,
      selectedTab: null,
      hasPulseAccess: hasPulseAccess(),
      calendarMethodology: null,
    };
  },
  computed: {
    displayRatingId() {
      return this.ratingId ? this.ratingId : RISK_RATING_PRIMARIES.political;
    },
  },
  async mounted() {
    this.calendarMethodology = await getCalendarMethodology();
  },
  watch: {
    showPopup() {
      this.selectedTab = TABS[this.initial];
    },
  },
};
</script>

<style scoped>
.newButton {
  padding: 2px;
  background-color: #ff9463;
  color: white;
  border-radius: 4px;
  font-size: xx-small;
  margin-left: -5px;
  position: relative;
  top: -2px;
}
</style>
